import { GAME_TYPES } from "./constants";

const BET_CODE_TO_GAME_ID = {
  single_digits: "single-digit",
  jodi: "jodi-digit",
  single_pana: "single-pana",
  double_pana: "double-pana",
  triple_pana: "triple-pana",
  half_sangam_a: "half-sangam-a",
  half_sangam_b: "half-sangam-b",
  full_sangam: "full-sangam",
  sp_motor: "sp-motor",
  dp_motor: "dp-motor",
  panel_group: "panel-group",
  red_bracket: "red-bracket",
  two_digits_panel: "two-digit-panel",
  sp_dp_tp: "sp-dp-tp",
  choice_pana: "choice-pana",
  digits_based_jodi: "digit-based-jodi",
  group_jodi: "group-jodi",
  odd_even: "odd-even",
  single_pana_bulk: "single-pana-bulk",
  double_pana_bulk: "double-pana-bulk",
};

function formatClock(time) {
  if (!time || typeof time !== "string") return "";
  const [hourPart, minutePart = "00"] = time.split(":");
  const hour = Number(hourPart);
  if (Number.isNaN(hour)) return time;
  const period = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12;
  return `${String(hour12).padStart(2, "0")}:${minutePart.padStart(2, "0")} ${period}`;
}

function formatResult(result) {
  const openPana = result?.open_pana || "***";
  const closePana = result?.close_pana || "***";
  let jodi = result?.jodi_digit;
  if (!jodi && result?.open_digit != null && result?.close_digit != null) {
    jodi = `${result.open_digit}${result.close_digit}`;
  }
  return `${openPana}-${jodi || "**"}-${closePana}`;
}

function formatStatus(market) {
  if (market?.session_status?.is_weekend_blocked || market?.market_status === "closed") {
    return "Bet is closed";
  }
  if (market?.market_status === "close") return "Bet is running for Close";
  if (market?.market_status === "open") return "Bet is running for Open";

  const sessions = market?.session_status?.sessions;
  if (sessions?.open?.is_open) return "Bet is running for Open";
  if (sessions?.close?.is_open) return "Bet is running for Close";
  return "Bet is closed";
}

export function mapMatkaMarket(market) {
  return {
    id: market.slug || String(market.id),
    marketId: market.id,
    name: market.name,
    titleForGames: `${market.name} Games`,
    status: formatStatus(market),
    numbers: formatResult(market.result),
    openTime: formatClock(market.open_time),
    closeTime: formatClock(market.close_time),
    isOpen: market.market_status !== "closed",
  };
}

export function mapMarketBetTypes(betTypes) {
  if (!Array.isArray(betTypes)) return [];

  return betTypes
    .filter((betType) => betType?.is_enable !== false)
    .map((betType) => {
      const id =
        BET_CODE_TO_GAME_ID[betType.code] ||
        String(betType.code || betType.id).replace(/_/g, "-");
      const known = GAME_TYPES.find((gameType) => gameType.id === id);

      return {
        id,
        code: betType.code,
        title: betType.name || known?.title || id,
        subtitle: known?.subtitle || "",
        icon: known?.icon || "single-digit",
        hasBulk: Boolean(known?.hasBulk),
        available: betType.available !== false,
        betDirection: betType.bet_direction || "both",
      };
    });
}

export function toMarketCards(markets) {
  if (!Array.isArray(markets)) return [];
  return markets
    .filter((market) => market?.enabled !== false && market?.platform_active !== false)
    .map(mapMatkaMarket);
}
